import SimpleTable from '_c/common/Table/Index.vue'
export default {
  data () {
    return {
      loading: false,
      dataSource: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 50,
        defaultPageSize: 50,
        pageSizeOptions: ['50', '100'],
        showSizeChanger: true,
        showQuickJumper: true,
        hideOnSinglePage: true
      },
      roleList: [
        {value: 2, name: '总负责人'},
        {value: 3, name: '档案室负责人'},
        {value: 4, name: '普通员工'}
      ],
      permissionList: [
        {value: 0, name: '不可访问'},
        {value: 1, name: '维护权'},
        {value: 2, name: '管理权'}
      ],
      dataTypeList: [1, 2, 3, 4],
      dataTypeObj: {
        1: {
          cn: '清单数据',
          en: 'inventory'
        },
        2: {
          cn: '定额数据',
          en: 'quota'
        },
        3: {
          cn: '组价数据',
          en: 'combination'
        },
        4: {
          cn: '人材机数据',
          en: 'material'
        }
      }
    }
  },
  filters: {
    formatFromList (value, list, from, to) {
      let str = ''
      list.forEach((item) => {
        if (item[from] === value) {
          str = item[to]
        }
      })
      if (str === '') { str = value }
      return str
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = this.getTableHeight('table-box')
      // 窗口大小改变时 触发
      this.resizeHandle.resize(() => {
        this.tableHeight = this.getTableHeight('table-box')
      })
      this.getMembers()
    })
  },
  methods: {
    // 调用查询接口
    handleTableChange (pagination) {
      console.log(pagination)
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getMembers()
    },
    // 1.1 分页切换
    handleCurrentChange (value) {
      this.pagination.current = value
      this.getMembers()
    },
    // 1.2 每一页显示条数切换
    handlePageSizeChange (value) {
      this.pagination.current = 1
      this.pagination.pageSize = value
      this.getMembers()
    }
  },
  components: {
    SimpleTable
  }
}
